// Libraries
import { NgModule } from '@angular/core';
import {
  HttpModule,
  Http
} from '@angular/http';
import { Angular2TokenService } from 'angular2-token';

// Services
import { HttpService } from './http.service';

/**
 * `CoreModule` Here you will export your layout modules, and all your core (singleton) services.
 * You only need to export (and not import) the modules, as nothing in the core module will actually use those layout modules.
 */
@NgModule({
  imports: [
    HttpModule
  ],
  providers: [
    { provide: Http, useClass: HttpService },
    Angular2TokenService
  ]
})
export class CoreModule {}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/core.module.ts